<template>
  <vs-popup
    :title="getTitle()"
    :active.sync="showThisPopup"
    @close="handleClose"
    class="edit-booking-popup"
  >
  <div v-if="rejectedRequests.length > 0">
        <div v-for="(enhRequest, index) in rejectedRequests"
          :key="index"
          class="
            bg-white
            shadow-xl
            mb-4
            rounded-xl
            tablet:flex
            overflow-hidden
            grid
            grid-cols-3
            justify-between
       
          "
          :style="{
            'background-color': 'rgb(255 244 244) !important'
          }"
          
        >
          <div class="p-6 px-8 flex justify-between  w-full  col-span-2 tablet:col-span-1">
            
            <div>

              <h4>
                {{
                  venues.find(
                    (v) =>
                      enhRequest.booking.venueDetailsId.id ===
                      v.venueDetailsId.id
                  ).name
                }}
                <span class="text-grey"
                  >- {{ enhRequest.booking.guestCount }} guests</span
                >
              </h4>
              <div class="flex" v-if="enhRequest.event">
                <vs-chip color="blue">
                  EVENT: {{ enhRequest.event.eventName }}
                </vs-chip>
              </div>
              <p class="text-grey">
                {{enhRequest.bookingCustomer ? enhRequest.bookingCustomer.name : "No name" }} - arrival:
                {{ formattedArrival(enhRequest.booking) }}
                <span
                  class="tag-badge lg:ml-2"
                  v-if="getThemeTagString(enhRequest)"
                  >{{ getThemeTagString(enhRequest) }}</span
                >
              </p>
              <div>
      
                <span v-if="!enhRequest.booking.caseworker" class="text-danger">
                  No caseworker</span
                >
                     
                <span
                  v-if="enhRequest.booking.caseworker"
                  class="text-primary bg-success"
                >
                  Caseworker:
                  {{ enhRequest.booking.caseworker.displayName }}</span
                >
                
              </div>
            </div>
      
          
            
            </div>

             <div
              class="order-last tablet:order-0 tablet:col-span-1 col-span-3 tablet:my-auto tablet:mr-4  "
              v-if="
                  $AuthService.hasPermissionForActiveVenue(
                    'vp.vp.booking.acceptrequestpendingrequests'
                  )
                "
             >
               <vs-button @click="activateRequest(enhRequest.booking)" class="w-full tablet:w-48 text-sm ">Activate request</vs-button>
            </div>
          
          <div
            class="rounded-r-xxl p-6 px-8 tablet:order-last"
            style="background-color: #f0f2f4 !important; min-width: 10rem"
          >
            <div v-if="enhRequest.booking.totalPrice">
              <p class="text-grey leading-none"><small>Preorders</small></p>
              <p>
                <small>{{ enhRequest.booking.totalPrice }}</small>
              </p>
            </div>
            <div v-if="enhRequest.booking.budget">
              <p class="text-grey leading-none"><small>Budget</small></p>
              <p>
                <small>{{
                  formatPrice(
                    enhRequest.booking.budget / 100,
                    enhRequest.booking.budgetCurrency
                  )
                }}</small>
              </p>
            </div>
          </div>
        </div>
    </div>
    <div v-else>
        <p>No rejected requests</p>
    </div>
  </vs-popup>
</template>

<script>
import moment from 'moment'
import * as _ from "lodash";
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      showThisPopup: false,
      rejectedRequests: [],
       THEME_OTHER: "THEME:OTHER",

    };
  },
  computed: {
    ...mapGetters({
      tags: "marcom/allBookingTags"
    }),
        venues() {
      var result = this.$store.state.marcom.venues;

      if (this.location)
        result = result.filter((v) => v.locationId.id == this.location.id);

      if (result.length == 0)
        result.push({
          name: "No venues",
          isNoResult: true,
        });

      return result;
    },
  },
  methods: {
    getTitle() {
     
      return "Rejected reqeusts";
    },
    async show(rejectedRequests) {
      this.rejectedRequests = rejectedRequests
      this.setTotalPrice()
      this.showThisPopup = true;
    },

    activateRequest(booking){
    this.$emit("request-activated",booking)
     this.rejectedRequests = this.rejectedRequests.filter((r) => r.booking.bookingId.id.toString() != booking.bookingId.id.toString())
    },
    setTotalPrice(){
    for (const enhRequest of this.rejectedRequests) {
        enhRequest.booking.totalPrice = this.formatPrice(
          this.getTotalPrice(enhRequest.booking),
          enhRequest.booking.orderLines.length > 0
            ? enhRequest.booking.orderLines[0].unitPrice.currency
            : ""
        );
      }
    },
    getTotalPrice(booking) {
      var tot = 0;
      for (const orderLine of booking.orderLines) {
        tot += this.getOrderlineTotalPrice(orderLine);
      }
      return tot;
    },
     getOrderlineTotalPrice(orderLine) {
      const intAmount = orderLine.quantity * orderLine.unitPrice.value;
      const decAmount = intAmount / 100;
      return decAmount;
    },

    handleClose() {
    this.showThisPopup = false;
    },
      formattedArrival(booking) {
      let date = moment(booking.arrival);
      return date.format("DD/MM - YYYY HH:mm");
    },
      getThemeTagString(enhancedBooking) {
      if (!enhancedBooking.booking.tags) return "";
      var result = enhancedBooking.booking.tags
        .map((bookingTag) => {
          if (bookingTag === null || bookingTag.indexOf("BOOKING_TYPE") >= 0)
            return "";
            
          var translation = this.tags.find((t) => t.tag === bookingTag);
          if (translation !== undefined)
            return translation.translations.find((t) => t.languageCode === "EN")
              .translation;

          if (_.startsWith(_.toUpper(bookingTag), `${this.THEME_OTHER}|`)) {

            return bookingTag.substring(`${this.THEME_OTHER}|`.length);
          }

          return bookingTag;
        })
        .filter((t) => t !== "")
        .join(", ");

      return result;
    },
     formatPrice(decAmount, currency) {
      var options = {};
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)

      if (currency)
        _.assign(options, { style: "currency", currency: currency });
      var formatter = new Intl.NumberFormat("en-US", options);

      return formatter.format(decAmount); /* $2,500.00 */
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-booking-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-popup--content {
    overflow: hidden;
  }
}
.booking-section {
  background: #f8f8f8;
}

.text-red {
  color: #aa0000;
}
.text-green {
  color: #00891b;
}

.layout-grid {
  @media only screen and (max-width: 801px) {
    display: block;
    grid-template-columns: 1fr 2fr;
  }

  display: grid;
  grid-template-columns: 5fr 2fr;
}

.vc-container {
  background: transparent;
  border: none;
}

.tag-badge {
  background: #b5b8bb50;
  color: #2222227e;
  padding: 1px;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
}
</style>
